class NostoAPILayer {
  constructor () {
    this.eventBus = window.theme.results.eventBus
    this.events = window.theme.results.events

    this.setupEventListeners()
    this.trackingEvents()
  }

  setupEventListeners () {
    this.eventBus.subscribe(window.theme.results.events.API.FETCH_PRODUCTS, () => {
      this.fetchProducts()
    })
  }

  trackingEvents () {
    this.eventBus.subscribe(this.events.TRACKING.PRODUCT_CLICKED, event => {
      window.nostojs(api => {
        const isTrackingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        if (!isTrackingAllowed) return

        api.recordSearchClick('serp', {
          productId: event.productId,
          url: event.productUrl,
        })
      })
    })

    this.eventBus.subscribe(this.events.TRACKING.PRODUCT_ADDED_TO_CART, event => {
      window.nostojs(api => {
        const isTrackingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed()
        if (!isTrackingAllowed) return

        api.recordSearchAddToCart('serp', {
          productId: event.productId,
          url: event.productUrl,
        })
      })
    })
  }

  calculatePaginationOffset (currentPage, productsPerPage) {
    if (currentPage <= 1) {
      return 0
    }
    return (currentPage - 1) * productsPerPage
  }

  async fetchProducts () {
    try {
      // eslint-disable-next-line no-undef
      nostojs(api => {
        const state = window.theme.results.stateLayer.state

        const activeFacets = state.activeFacets.map(facet => {
          if (facet.field === 'price' && facet.value?.length) {
            const [min, max] = facet.value[0].split('~')
            return { field: facet.field, range: { gte: min, lte: max } }
          }
          return facet
        })

        const currentPage = state.pagination.currentPage || 1
        const productsPerPage = state.productsPerPage
        const apiFrom = this.calculatePaginationOffset(currentPage, productsPerPage)
        const payload = window.location.pathname.includes('/search')
          ? this.searchPayload(
            this.normalizeSearchQuery(state.activeTerm),
            activeFacets,
            apiFrom,
            productsPerPage,
            state,
          )
          : this.categoryPayload(
            this.categoryId,
            this.categoryPath,
            activeFacets,
            apiFrom,
            productsPerPage,
            state,
          )

        api
          .search(payload, {
            track: state.activeTerm.trim().length > 0 ? 'serp' : false,
            redirect: true,
          })
          .then(response => {
            const API = window.theme.results.events.API
            this.eventBus.publish(API.PRODUCTS_FETCHED, response)

            const facets = response.products.facets || []
            this.eventBus.publish(API.FACETS_FETCHED, facets)
          })
          .catch(error => {
            console.error('Failed to fetch products from Nosto:', error)
            this.eventBus.publish(window.theme.results.events.API.SHOPIFY_FALLBACK, {})
          })
      })
    } catch (error) {
      console.error('NostoJS API call failed:', error)
      this.eventBus.publish(window.theme.results.events.API.SHOPIFY_FALLBACK, {})
    }
  }

  categoryPayload (categoryId, categoryPath, activeFacets, apiFrom, productsPerPage, state) {
    return {
      products: {
        categoryId,
        categoryPath,
        facets: ['*'],
        fields: [
          'name',
          'productId',
          'variantId',
          'imageUrl',
          'tags1',
          'alternateImageUrls',
          'price',
          'listPrice',
          'productType',
          'url',
          'skus.name',
          'skus.id',
          'skus.inventoryLevel',
          'skus.price',
          'description',
          'customFields.key',
          'customFields.value',
        ],
        filter: activeFacets,
        from: apiFrom,
        sort: state.activeSort || [],
        size: productsPerPage,
      },
    }
  }

  normalizeSearchQuery (q) {
    return (q ?? '').trim().replace(/\s+/g, ' ')
  }

  searchPayload (query, activeFacets, apiFrom, productsPerPage, state) {
    return {
      query,
      products: {
        facets: ['*'],
        fields: [
          'name',
          'productId',
          'variantId',
          'imageUrl',
          'tags1',
          'alternateImageUrls',
          'price',
          'listPrice',
          'productType',
          'url',
          'skus.name',
          'skus.id',
          'skus.inventoryLevel',
          'description',
          'customFields.key',
          'customFields.value',
        ],
        filter: activeFacets,
        from: apiFrom,
        sort: state.activeSort || [],
        size: productsPerPage,
      },
    }
  }

  get categoryId () {
    return document.body.dataset.categoryId
  }

  get categoryPath () {
    return document.body.dataset.categoryPath
  }
}

window.theme.results.apiLayer = new NostoAPILayer()
